/* Sale badges: Black Friday ribbon window + product page variant updates.
   Window comes from theme settings (window.ssSaleBadges, set in ss-sale-badges-assets).
   The time check runs in the browser so a cached page still flips on time.
   ?bf_preview=1 forces the ribbon on for this browser tab (?bf_preview=0 clears it). */
(function () {
  if (window.ssSaleBadgesLoaded) return;
  window.ssSaleBadgesLoaded = true;

  var config = window.ssSaleBadges || {};
  var root = document.documentElement;
  var MAX_TIMER_MS = 24 * 60 * 60 * 1000;

  function previewForced() {
    var param = new URLSearchParams(window.location.search).get('bf_preview');
    try {
      if (param === '1') sessionStorage.setItem('ss_bf_preview', '1');
      if (param === '0') sessionStorage.removeItem('ss_bf_preview');
      return sessionStorage.getItem('ss_bf_preview') === '1';
    } catch (e) {
      return param === '1';
    }
  }

  var forced = previewForced();
  var start = Date.parse(config.bfStart);
  var end = Date.parse(config.bfEnd);

  function updateRibbon() {
    var now = Date.now();
    var live = forced || (!isNaN(start) && !isNaN(end) && now >= start && now < end);
    root.classList.toggle('ss-bf-live', live);

    // Flip again at the next boundary if the page stays open across it.
    var next = now < start ? start : now < end ? end : NaN;
    if (!forced && !isNaN(next) && next - now < MAX_TIMER_MS) {
      setTimeout(updateRibbon, next - now + 1000);
    }
  }

  updateRibbon();

  // Product page: follow the selected variant. Dawn publishes the new variant's
  // presentment price and compare-at price (in cents) on every variant change.
  function updateProductBadges(variant, sectionId) {
    var scope = document.getElementById('MediaGallery-' + sectionId) || document;
    var badges = scope.querySelector('.ss-sale-badges--product');
    if (!badges) return;
    var tag = badges.querySelector('[data-ss-sale-tag]');
    var min = parseInt(badges.dataset.min, 10) || 5;
    var price = variant ? variant.price : 0;
    var compare = variant ? variant.compare_at_price : 0;
    var onSale = !!(compare && compare > price);
    var pct = onSale ? Math.floor(((compare - price) * 100) / compare) : 0;

    badges.toggleAttribute('data-on-sale', onSale);
    if (tag) {
      tag.textContent = pct + '% OFF';
      tag.hidden = !onSale || pct < min || config.tagEnabled === false;
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data) updateProductBadges(event.data.variant, event.data.sectionId);
    });
  }
})();
